import ProviderMenu from './ProviderMenu/ProviderMenu'

export default ProviderMenu
